import { startOfDay } from './datetime';

const GROUP_GAP_MS = 5 * 60 * 1000;

function authorKey(message) {
  const user = message.user || {};
  if (user.id != null) return 'id:' + user.id;
  if (user.type) return 'type:' + user.type;
  return 'unknown';
}

function messageKey(message) {
  if (message.id != null) return 'm-' + message.id;
  if (message.localId != null) return 'lm-' + message.localId;
  return 'm-' + message.created;
}

/**
 * Превращает плоский список сообщений (по возрастанию времени) в поток
 * элементов для рендера: разделители дней + сообщения с флагами группировки
 * (подряд идущие от одного автора в пределах 5 минут склеиваются).
 *
 * @returns {Array<
 *   {kind: 'day', id: string, value: string} |
 *   {kind: 'message', id: string, message: object, firstOfGroup: boolean, lastOfGroup: boolean}
 * >}
 */
export function buildMessageStream(messages) {
  const items = [];
  let prev = null;
  let prevDay = null;

  messages.forEach((message) => {
    const day = startOfDay(message.created);

    if (day !== prevDay) {
      items.push({ kind: 'day', id: 'day-' + day, value: message.created });
      prevDay = day;
      prev = null;
    }

    const grouped =
      prev &&
      authorKey(prev) === authorKey(message) &&
      Math.abs(new Date(message.created).getTime() - new Date(prev.created).getTime()) < GROUP_GAP_MS;

    if (grouped && items.length) {
      const last = items[items.length - 1];
      if (last.kind === 'message') last.lastOfGroup = false;
    }

    items.push({
      kind: 'message',
      id: messageKey(message),
      message,
      firstOfGroup: !grouped,
      lastOfGroup: true,
    });

    prev = message;
  });

  return items;
}
